
if($('.grid__item').hasClass('last_hide')){
      $('#product-grid .grid__item').show();
     $('#product-grid .grid__item:last').hide();
    }
function loadMoreProducts() {
 $('button.load-more_btn.btn').attr('disabled',true);
 var products_on_page = $(".products-on-page");
var next_url = $('#Huratips-Pagination a').attr("href");
  console.log(next_url);
 if(next_url !='' && next_url != 'undefined'){
var load_more_btn = $(".load-more_btn ");
var load_more_spinner = $(".load-more_spinner");
  $.ajax({
    url: next_url,
    type: "GET",
    dataType: "html",
    beforeSend: function () {
      load_more_btn.hide();
      load_more_spinner.show();
    },
  }).done(function (next_page) {
    load_more_spinner.hide();
   var new_products = $(next_page).find(".products-on-page");
    var new_url = $(next_page).find('#Huratips-Pagination a').attr("href");
     $('#Huratips-Pagination a').attr("href",new_url);
     $('.pagination_number').attr("next-url"); 
    products_on_page.append(new_products.html());
    if($('.grid__item').hasClass('last_hide')){
      $('#product-grid .grid__item').show();
     $('#product-grid .grid__item:last').hide();
    }
    load_more_btn.show();
     if (new_url){ load_more_btn.show();$('button.load-more_btn.btn').attr('disabled',false);}else{$('#product-grid .grid__item').show(); $('button.load-more_btn.btn').attr('disabled',true);}
     if(new_url == undefined){
     $('button.load-more_btn.btn').remove();
     }
  });
 }
}

// function isInView(elem){
//    return $(elem).offset().top - $(window).scrollTop() < 800 && $(elem).offset().top - $(window).scrollTop() >0;
    
// }
// $(window).scroll(function(){
//    if(isInView($('.load-more .load-more_btn')) ==  true){
//       $('.load-more .load-more_btn').trigger('click');
//    }
// })



// to solve the console error start

function isInView(elem) {
    if (!elem.length) return false;

    const top = elem.offset()?.top;
    if (top === undefined) return false;

    const distance = top - $(window).scrollTop();
    return distance < 800 && distance > 0;
}

$(window).scroll(function () {
    const btn = $('.load-more .load-more_btn');
       
    if (isInView(btn)) {
        btn.trigger('click');
    }
});

// to solve the console error end



